// Endless recent searches dropdown
// Shows last 5 search queries when search input is focused and empty
// Also sends search events to GA4 for analytics

(function () {
  const STORAGE_KEY = 'endless_recent_searches';
  const MAX_HISTORY = 5;

  function getRecent() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(query) {
    if (!query || query.length < 2) return;
    try {
      const current = getRecent();
      const filtered = current.filter(
        q => q.toLowerCase() !== query.toLowerCase()
      );
      filtered.unshift(query);
      const trimmed = filtered.slice(0, MAX_HISTORY);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) {}
  }

  function removeRecent(query) {
    try {
      const current = getRecent();
      const filtered = current.filter(
        q => q.toLowerCase() !== query.toLowerCase()
      );
      localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch (e) {}
  }

  // Send custom event to GA4 with the search term
  function trackSearchEvent(query, source) {
    const eventData = {
      search_term: query,
      search_source: source,
      recent_searches_count: getRecent().length
    };

    if (typeof gtag === 'function') {
      gtag('event', 'endless_search', eventData);
    }
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'endless_search', ...eventData });
    }
  }

  // Save query when user lands on search results page + fire GA4 event
  if (window.location.pathname.startsWith('/search')) {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get('q') || '').trim();
    if (q) {
      saveRecent(q);
      trackSearchEvent(q, 'search_results_page');
    }
  }

  function buildDropdown() {
    const dropdown = document.createElement('div');
    dropdown.className = 'endless-recent-searches';
    dropdown.style.cssText = [
      'position: absolute',
      'background: #fff',
      'border: 1px solid #e6dfd2',
      'border-top: none',
      'box-shadow: 0 4px 12px rgba(0,0,0,0.08)',
      'z-index: 9999',
      'font-size: 14px',
      'line-height: 1.4',
      'display: none',
      'max-height: 280px',
      'overflow-y: auto'
    ].join(';');
    return dropdown;
  }

  function renderItems(dropdown, input) {
    const recent = getRecent();
    if (recent.length === 0) {
      dropdown.style.display = 'none';
      return;
    }

    dropdown.innerHTML = '';

    const header = document.createElement('div');
    header.style.cssText = [
      'padding: 10px 14px 6px',
      'font-size: 11px',
      'letter-spacing: 0.05em',
      'text-transform: uppercase',
      'color: #999',
      'border-bottom: 1px solid #f0ebe1'
    ].join(';');
    header.textContent = 'Recent searches';
    dropdown.appendChild(header);

    recent.forEach(query => {
      const row = document.createElement('div');
      row.style.cssText = [
        'display: flex',
        'align-items: center',
        'justify-content: space-between',
        'padding: 10px 14px',
        'cursor: pointer',
        'color: #1a1a1a',
        'transition: background 0.15s'
      ].join(';');
      row.onmouseenter = () => (row.style.background = '#faf7f2');
      row.onmouseleave = () => (row.style.background = '#fff');

      const text = document.createElement('span');
      text.textContent = query;
      text.style.cssText = 'flex: 1; padding-right: 12px;';
      text.onclick = () => {
        // Track that the user reused a recent search
        const positionInHistory = getRecent().indexOf(query) + 1;
        if (typeof gtag === 'function') {
          gtag('event', 'recent_search_clicked', {
            search_term: query,
            position_in_history: positionInHistory
          });
        }
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'recent_search_clicked',
            search_term: query,
            position_in_history: positionInHistory
          });
        }

        const form = input.closest('form');
        input.value = query;
        if (form) {
          form.submit();
        } else {
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        }
      };

      const remove = document.createElement('span');
      remove.textContent = '×';
      remove.style.cssText = [
        'color: #999',
        'font-size: 18px',
        'line-height: 1',
        'padding: 0 4px',
        'cursor: pointer'
      ].join(';');
      remove.onclick = (e) => {
        e.stopPropagation();
        removeRecent(query);
        renderItems(dropdown, input);
      };

      row.appendChild(text);
      row.appendChild(remove);
      dropdown.appendChild(row);
    });

    const clearAll = document.createElement('div');
    clearAll.style.cssText = [
      'padding: 8px 14px 12px',
      'border-top: 1px solid #f0ebe1',
      'font-size: 12px',
      'color: #999',
      'cursor: pointer',
      'text-align: center'
    ].join(';');
    clearAll.textContent = 'Clear all';
    clearAll.onmouseenter = () => (clearAll.style.color = '#1a1a1a');
    clearAll.onmouseleave = () => (clearAll.style.color = '#999');
    clearAll.onclick = () => {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      dropdown.style.display = 'none';
    };
    dropdown.appendChild(clearAll);

    dropdown.style.display = 'block';
  }

  function positionDropdown(dropdown, input) {
    const anchor = input.closest('form') || input;
    const rect = anchor.getBoundingClientRect();
    dropdown.style.top = `${rect.bottom + window.scrollY}px`;
    dropdown.style.left = `${rect.left + window.scrollX}px`;
    dropdown.style.width = `${rect.width}px`;
  }

  function attach(input) {
    if (input.dataset.endlessRecentAttached) return;
    input.dataset.endlessRecentAttached = '1';

    const dropdown = buildDropdown();
    document.body.appendChild(dropdown);

    function maybeShow() {
      if (input.value.trim().length === 0) {
        positionDropdown(dropdown, input);
        renderItems(dropdown, input);
      } else {
        dropdown.style.display = 'none';
      }
    }

    input.addEventListener('focus', maybeShow);
    input.addEventListener('input', maybeShow);
    window.addEventListener('resize', () => {
      if (dropdown.style.display === 'block') {
        positionDropdown(dropdown, input);
      }
    });

    document.addEventListener('mousedown', (e) => {
      if (!dropdown.contains(e.target) && e.target !== input) {
        dropdown.style.display = 'none';
      }
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') dropdown.style.display = 'none';
    });
  }

  function init() {
    const inputs = document.querySelectorAll('input[name="q"]');
    inputs.forEach(input => {
      const rect = input.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      attach(input);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => init());
  observer.observe(document.body, { childList: true, subtree: true });
})();